import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal'; 

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnChanges  {
  modalRef: BsModalRef; 
  @Input() isDataEntered;

  checkStatus;

  constructor(private _router:Router, private modalService: BsModalService) { }
  ngOnChanges(changes: SimpleChanges): void {
    for (let property in changes) {
      if (property === 'isDataEntered') {
this.checkStatus = changes[property].currentValue;
      } 
  }
  }
  
  openModalWithClass(template: TemplateRef<any>) {
    if(this.checkStatus == true){
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: 'gray modal-lg' })
      );
    }else{
      // this.modalRef.hide();
      this._router.navigate(['/dashboard']);
    }
   
  }
  gotoDashboard() {
    this.modalRef.hide();
    this._router.navigate(['/dashboard']);
  }
  onDataEntered(_dataEntered){

  }

}
